export const ROLES = {
  ADMIN: 'admin',
  STAFF: 'staff',
  USER: 'user',
};

export const hasRole = (user, roles) => {
  const role = user?.role;
  if (!role) return false;
  const allowed = Array.isArray(roles) ? roles : [roles];
  return allowed.includes(role);
};

export const isAdmin = (user) => hasRole(user, ROLES.ADMIN);

export const canManageData = (user) => hasRole(user, [ROLES.ADMIN, ROLES.STAFF]);

export const canAccessApp = canManageData;

export const homePathForRole = (role) => {
  if (role === ROLES.ADMIN) return '/dashboard';
  if (role === ROLES.STAFF) return '/admin/companies';
  return '/';
};

export const getUserRoleName = (user) => {
  if (user?.role) {
    return user.role;
  }
  const names = user?.roles?.map((role) => role.name) || [];
  if (names.includes(ROLES.ADMIN)) return ROLES.ADMIN;
  if (names.includes(ROLES.STAFF)) return ROLES.STAFF;
  return names[0] || ROLES.USER;
};

/** Numeric user id from login payload (`user_id`) or API user objects (`id`). */
export const getCurrentUserId = (user) => {
  if (user == null) return null;
  const id = user.id ?? user.user_id;
  return id != null ? String(id) : null;
};
